import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";


const routes = [
  {
    path: '/login',
    name: '登录',
    component: () => import('../views/Login/Login'),
    meta: { requireAuth: true },
    children: []
  },
  {
    path: '/',
    name: '',
    component: () => import('../views/Index/Index'),
    meta: { requireAuth: true },
    children: [
      {
        path: '/user/setting',
        name: '用户配置',
        component: () => import('../views/User/setting'),
        meta: { requireAuth: true },
        children: []
      },
      {
        path: '/drawdown/dralist',
        name: '回撤管理',
        component: () => import('../views/Drawdown/dralist'),
        meta: { requireAuth: true },
        children: []
      }, 
      {
        path: '/strategy/strlist',
        name: '策略管理',
        component: () => import('../views/Strategy/strlist'),
        meta: { requireAuth: true },
        children: []
      }, 
      {
        path: '/orders/olist',
        name: '订单记录',
        component: () => import('../views/Orders/olist'),
        meta: { requireAuth: true },
        children: []
      }, 
      {
        path: '/notice/settings',
        name: '通知配置',
        component: () => import('../views/Notice/settings'),
        meta: { requireAuth: true },
        children: []
      }, 
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;